import React from 'react';
import { BooleanField, Datagrid, List, TextField } from 'react-admin';
import { CustomDateField } from '../../../../commonComponents/DateField';
import CustomReportListActions from '../../../../commonComponents/ListActions/CustomReportListActions';
import JigsawGameFilter from './JigsawGameFilter';

const JigsawGameList = (props) => (
  <List
    title="Jigsaw Game reports"
    actions={<CustomReportListActions />}
    filters={<JigsawGameFilter />}
    bulkActionButtons={false}
    sort={{ field: 'user_id', order: 'DESC' }}
    {...props}
  >
    <Datagrid>
      <TextField label="ID" source="id" sortable={false} />
      <TextField label="User ID" source="user_id" sortBy="user_id" sortable={true} />
      <TextField label="Jigsaw game ID" source="jigsaw_event_id" sortable={true} />
      <CustomDateField label="Date created" source="game_date" sortable={true} showTime={false} locales={'hu'} />
      <TextField label="Difficulty" source="difficulty" />
      <TextField label="Check count" source="check_count" />
      <TextField label="Hints used" source="hints_used" />
      <TextField label="Total hints earned" source="total_hints_earned" />
      <TextField label="Moves total" source="moves_total" />
      <TextField label="Solved game" source="solved_game" />
      <TextField label="Total coins earned" source="total_coins_earned" />
      <BooleanField label="Earned 2000 credits" source="earned_2000_credits" />
      <BooleanField label="Has completed quests" source="has_completed_quests" />
    </Datagrid>
  </List>
);

export default JigsawGameList;
